import { createServiceFetchError } from 'owa-service-utils/lib/createServiceFetchError';
import { OCPSErrorResponse } from '../schema/OCPSErrorResponse';
import { OCPSPolicyResponse } from '../schema/OCPSPolicyResponse';

const HTTP_RESPONSE_OK = 200;
const HTTP_RESPONSE_NO_CONTENT = 204;

export const getSuccessfulResponsePolicies = async (
    response: Response
): Promise<OCPSPolicyResponse> => {
    if (!response) {
        return Promise.reject(
            createServiceFetchError('500', 'Server returned a null response', null)
        );
    }

    switch (response.status) {
        case HTTP_RESPONSE_NO_CONTENT:
            /**
             * 204 means that the policies are not set up.
             * If status is 204 then set the response value as null so that the default
             * policy values get applied
             */
            return Promise.resolve(null);
        case HTTP_RESPONSE_OK:
            try {
                const policiesResponse = await getParsedResponse(response);
                return policiesResponse as OCPSPolicyResponse;
            } catch (error) {
                return Promise.reject(error);
            }
        default:
            try {
                const errorResponse = await getParsedResponse(response);
                const { Error } = (errorResponse as OCPSErrorResponse) ?? {};
                return Promise.reject(createServiceFetchError(Error?.Code, Error?.Message, null));
            } catch (error) {
                return Promise.reject(error);
            }
    }
};

const getParsedResponse = async (
    response: Response
): Promise<OCPSPolicyResponse | OCPSErrorResponse> => {
    try {
        const parsedResponse: OCPSPolicyResponse | OCPSErrorResponse = await response.json();
        return parsedResponse;
    } catch (error) {
        return Promise.reject(
            createServiceFetchError(`${response.status}`, 'Cannot parse response.', error.message)
        );
    }
};
